import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  body {
    font-family: ${props => props.theme.fonts.primary};
    background-color: ${props => props.theme.colors.background};
    color: ${props => props.theme.colors.text};
    line-height: 1.6;
  }

  .app-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  .main-content {
    flex: 1;
    padding: ${props => props.theme.spacing.lg};
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
  }

  a {
    color: ${props => props.theme.colors.secondary};
    text-decoration: none;
    transition: ${props => props.theme.transitions.short};

    &:hover {
      color: ${props => props.theme.colors.opplaneBlue};
    }
  }

  button {
    cursor: pointer;
    font-family: ${props => props.theme.fonts.primary};
  }

  h1, h2, h3, h4, h5, h6 {
    margin-bottom: ${props => props.theme.spacing.md};
    font-weight: 500;
    line-height: 1.2;
  }

  p {
    margin-bottom: ${props => props.theme.spacing.md};
  }

  input, select, textarea {
    font-family: ${props => props.theme.fonts.primary};
  }
`;

export default GlobalStyle;
